import { action } from 'satcheljs/lib/legacy';
import moveToMenuStore from '../store/store';
import setNewFolderInvalidState from './setNewFolderInvalidState';
/**
 * Sets the text for the new folder
 * @param text the new folder name
 */
export default action('setNewFolderText')(function setNewFolderText(text) {
    moveToMenuStore.newFolderViewState.folderText = text;
    setNewFolderInvalidState(false /* isInvalid */);
});
//# sourceMappingURL=setNewFolderText.js.map